import ResourceList from "components/resources/ResourceList";
import * as React from 'react';
export default {
  ResourceList,
  React
};